module.exports = __webpack_public_path__ + "img/cyprus.d2e18ce7.svg";